
import Layout from "@/components/Layout";
import YouTubeVideoHero from "@/components/YouTubeVideoHero";
import BrandMission from "@/components/homepage/BrandMission";
import GlowAppSimple from "@/components/homepage/GlowAppSimple";
import GlowAppCinematicScroll from "@/components/homepage/GlowAppCinematicScroll";
import SignatureTreatmentsGrid from "@/components/homepage/SignatureTreatmentsGrid";
import SimplifiedMembership from "@/components/homepage/SimplifiedMembership";
import JUVComparison from "@/components/homepage/JUVComparison";
import LocationExpansion from "@/components/homepage/LocationExpansion";
import FounderStatement from "@/components/homepage/FounderStatement";
import MetaTags from "@/components/SEO/MetaTags";
import { trackPageView } from "@/utils/analytics";
import { useEffect } from "react";

const Index = () => {
  useEffect(() => {
    // Track homepage view
    trackPageView('/', 'JUV Medspa™ - Feel Good in Your Skin Every Day');
  }, []);

  return (
    <>
      <MetaTags 
        title="JUV Medspa™ - Feel Good in Your Skin Every Day"
        description="Botox, fillers, facials, and more — all under one roof. At JUV, we make it easy to glow on your terms with memberships, same-day treatments, and real results."
        keywords={['medspa', 'botox', 'dermal fillers', 'facial treatments', 'aesthetic medicine', 'beauty treatments', 'medical spa', 'wellness']}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'MedicalBusiness',
          'name': 'JUV Medspa™',
          'description': 'Premium aesthetic treatments and wellness services',
          'url': 'https://juvmedspa.com',
          'telephone': '+1-555-JUV-GLOW',
          'priceRange': '$$',
          'medicalSpecialty': 'Aesthetic Medicine'
        }}
      />
      <Layout>
        <div className="overflow-x-hidden">
          <YouTubeVideoHero />
          <BrandMission />
          <GlowAppSimple />
          <GlowAppCinematicScroll />
          <SignatureTreatmentsGrid />
          <SimplifiedMembership />
          <JUVComparison />
          <LocationExpansion />
          <FounderStatement />
        </div>
      </Layout>
    </>
  );
};

export default Index;
